import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { ArrowLeft, Handshake, ChevronRight, Search } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL || ''}/api`;

export default function MobileCRMBrokersPage() {
  const navigate = useNavigate();
  const [brokers, setBrokers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get(`${API}/crm/brokers`).then(r => setBrokers(r.data || [])).catch(() => {}).finally(() => setLoading(false));
  }, []);

  if (loading) return <div className="mobile-page"><div className="mobile-loading"><div className="mobile-spinner" /></div></div>;

  return (
    <div className="mobile-page">
      <button className="mobile-back-btn" onClick={() => navigate('/mobile/more')}><ArrowLeft size={18} /> More</button>
      <div className="mobile-page-title" style={{ marginBottom: 12 }}>Brokers</div>
      <div className="mobile-kpi-row" style={{ marginBottom: 14 }}>
        <div className="mobile-kpi-card blue"><div className="mobile-kpi-label">Total</div><div className="mobile-kpi-value">{brokers.length}</div></div>
      </div>
      {brokers.length === 0 ? <div className="mobile-empty-state"><Handshake /><p>No brokers</p></div> : (
        <div className="mobile-menu-list">
          {brokers.map(b => (
            <button key={b.broker_id || b.id} className="mobile-menu-item" onClick={() => navigate('/mobile/crm/brokers')}>
              <div className="mobile-menu-item-icon" style={{ background: '#5856d6' }}><Handshake size={16} /></div>
              <div className="mobile-menu-item-content">
                <div className="mobile-menu-item-title">{b.company_name || b.contact_name || 'Broker'}</div>
                <div className="mobile-menu-item-subtitle">{b.contact_name || ''} · {b.commission_rate ? `${b.commission_rate}%` : 'N/A'}</div>
              </div>
              <ChevronRight size={16} className="mobile-menu-item-chevron" />
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
